import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function CTASection() {
  return <section id="cta-section" className="py-24 bg-forest relative overflow-hidden" data-id="element-1">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-golden/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-3" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-5">
          <div className="flex justify-center gap-1 mb-6" data-id="element-6">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 text-golden fill-current" data-id="element-7" />)}
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-warm-white mb-6 font-serif" data-id="element-8">
            Recupera tu tiempo y tu sazón hoy mismo
          </h2>

          <p className="text-xl text-warm-white/90 mb-10 leading-relaxed" data-id="element-9">
            Por solo{' '}
            <span className="text-golden font-bold text-2xl" data-id="element-10">$6,39</span> (el
            precio de un combo de hamburguesa agrandado), puedes transformar tus
            cenas para siempre.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-11">
            <Button id="cta-download-btn" variant="primary" href="https://almadigitalebooks.digital/cart/43078903136374:1" className="w-full sm:w-auto text-xl px-12 py-6 bg-golden text-forest hover:bg-white hover:text-forest font-bold shadow-2xl" onClick={() => {
            if (typeof (window as any).fbq === 'function') {
              ;
              (window as any).fbq('track', 'AddToCart', {
                value: 6.39,
                currency: 'USD',
                content_name: 'Smart Meal Prep USA - Edición Latina',
                content_type: 'product'
              });
            }
          }} data-id="element-12">
              Descargar Guía por $6,39
              <ArrowRight className="ml-2 h-6 w-6" data-id="element-13" />
            </Button>
            <p className="text-sm text-warm-white/60 mt-4" data-id="element-14">
              🔒 Pago seguro • Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}